module.exports = __webpack_public_path__ + "img/1080_20.18267cc5.jpg";